import { render } from "./topPIckItem.vue?vue&type=template&id=10324b74&scoped=true"
import script from "./topPIckItem.vue?vue&type=script&lang=js"
export * from "./topPIckItem.vue?vue&type=script&lang=js"

import "./topPIckItem.vue?vue&type=style&index=0&id=10324b74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10324b74"]])

export default __exports__